import React from 'react';
import Navbar from './Navbar'; 
import './App.css'; 
import ImageGallery from './ImageGallery';
import logo from './img/logo8.png';

import Lino from './img/Studio/linocutcover.jpg'
import Mind from './img/Studio/mindcover.jpg'


import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import Sidebar from './Sidebar';

const images = [
  { src: Mind, alt: 'Acrylic on Canvas'},
  { src: Lino, alt: 'Carve Ink Press'},

  
];



const Studio = () => {
  

  return (
   
      <div className="App">
        
            <div className='content'>
              <ImageGallery images={images} />
            </div>
        
      </div>
    
  );


  }
export default Studio;
